import React, { useState } from "react";
import PageHero from "../components/dental/PageHero";
import SectionTitle from "../components/dental/SectionTitle";
import Button from "../components/dental/Button";
import { ChevronDown, FileText, CreditCard, Calendar, Shield } from "lucide-react";
import { faqs } from "../mock";
// import VideoTestimonialsFilmRoll from "../components/dental/VideoTestimonialsFilmRoll";

const infoCards = [
  { icon: FileText, title: "New Patient Forms", desc: "Complete your paperwork from home so we can spend your visit relaxing, not writing." },
  { icon: CreditCard, title: "Insurance & Financing", desc: "Most major PPOs accepted. We also offer CareCredit and in-house payment plans." },
  { icon: Calendar, title: "Your First Visit", desc: "Plan 75–90 minutes for a full exam, digital imaging and personalized consultation." },
  { icon: Shield, title: "Safety & Comfort", desc: "Hospital-grade sterilization, HEPA air filtration and sedation options on request." },
];

const ForPatients = () => {
  const [open, setOpen] = useState(-1);
  return (
    <>
      <PageHero
        subtitle="Information"
        title="For Patients"
        breadcrumb="For Patients"
        image="https://galleria-dental-media.s3.eu-north-1.amazonaws.com/uploads/gallery/88317ffa-742f-4f12-b26d-192ace3481f7.jpeg"
      />
    {/* <VideoTestimonialsFilmRoll /> */}

      <section className="bg-[#FBF8F1] py-10 ">
        <div className="max-w-7xl mx-auto px-6">
          {/* <SectionTitle script="What To" title="Expect" subtitle="Everything you need" /> */}
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-2">
            {infoCards.map(({ icon: Icon, title, desc }) => (
              <div key={title} className="relative bg-[#ffffff] p-7 text-center border border-[#B79A68]/30">
                <div className="w-14 h-14 rounded-full border border-[#B79A68] flex items-center justify-center mx-auto mb-4 text-[#7D6A42]">
                  <Icon size={22} />
                </div>
                <h3 className="font-cinzel text-sm gold-gradient-text uppercase tracking-[0.15em] mb-3">{title}</h3>
                <p className="text-[#4E5750]/80 text-sm leading-relaxed">{desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-[#ffffff] py-20 border-t border-[#B79A68]/15">
        <div className="max-w-7xl mx-auto px-6">
          <SectionTitle script="" title="Frequently Asked Questions" subtitle="" />
          <div className="mt-10 grid md:grid-cols-2 gap-3 md:gap-4 items-start">
            {faqs.map((f, idx) => {
              const isOpen = open === idx;
              const answerParagraphs = Array.isArray(f.a)
                ? f.a
                : String(f.a)
                    .split(/\n\s*\n/)
                    .map((paragraph) => paragraph.trim())
                    .filter(Boolean);
              return (
                <div key={`${f.q}-${idx}`} className="border border-[#B79A68]/30 bg-[#ffffff] self-start h-fit">
                  <button
                    onClick={() => setOpen(isOpen ? -1 : idx)}
                    className="w-full flex items-center justify-between text-left px-5 py-4 hover:bg-[#FBF8F1] transition-colors"
                  >
                    <span className="font-cinzel uppercase text-sm tracking-[0.12em] gold-gradient-text">
                      {f.q}
                    </span>
                    <ChevronDown
                      size={18}
                      className={`text-[#7D6A42] transition-transform ${isOpen ? "rotate-180" : ""}`}
                    />
                  </button>
                  {isOpen && (
                    <div className="px-5 pb-5 text-[#4E5750]/85 leading-relaxed text-sm space-y-3">
                      {answerParagraphs.map((paragraph, paragraphIndex) => (
                        <p key={`${f.q}-${idx}-${paragraphIndex}`}>{paragraph}</p>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
          {/* <div className="text-center mt-12">
            <Button to="/contact">Schedule Your Visit</Button>
          </div> */}
        </div>
      </section>
    </>
  );
};

export default ForPatients;
